// extracted by mini-css-extract-plugin
export default {"ExternalUserList":"ExternalUserList_ExternalUserList__Gkd8E","name":"ExternalUserList_name__27I1B","email":"ExternalUserList_email__VDUUu","phone":"ExternalUserList_phone__68pum"};